module.exports = __webpack_public_path__ + "assets/static/jpg/banner1.c28dc24e61b32ef73c918d9124c12d8a.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/main/images/banner1.jpg
 ** module id = 486
 ** module chunks = 1
 **/